import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import '../styles/DriverView.css';
import apiService from '../services/apiService';

/**
 * Vista del Motorizado - Vista simplificada para el repartidor
 * Muestra la ruta del día y permite marcar entregas como completadas
 */
const DriverView = ({ selectedDate }) => {
  const [route, setRoute] = useState(null);
  const [currentStop, setCurrentStop] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadTodayRoute();
  }, [selectedDate]);

  const loadTodayRoute = async () => {
    console.log('🔍 ===== INICIO loadTodayRoute (DriverView) =====');
    console.log('📅 Fecha seleccionada:', selectedDate);

    setLoading(true);
    try {
      console.log('🌐 Llamando a API: getSavedRoutes con fecha:', selectedDate);

      // Obtener rutas del día con estado 'pending' o 'in_progress'
      const routes = await apiService.getSavedRoutes(selectedDate);

      console.log('📦 Respuesta de API:', routes);
      console.log('📊 Cantidad de rutas recibidas:', (routes && routes.length) || 0);

      if (routes && routes.length > 0) {
        console.log('📋 Lista de rutas:');
        routes.forEach((route, index) => {
          console.log(`  ${index + 1}. ID: ${route.id}, Nombre: ${route.name}, Status: ${route.status}, Stops: ${(route.stops && route.stops.length) || 0}`);
        });
      }

      if (!routes || routes.length === 0) {
        console.log('⚠️ No hay rutas para la fecha seleccionada');
        toast.info('No hay rutas activas para hoy');
        setRoute(null);
        setLoading(false);
        console.log('🔍 ===== FIN loadTodayRoute (sin rutas) =====');
        return;
      }

      // Buscar la primera ruta activa (pending o in_progress)
      console.log('🔍 Buscando ruta activa (pending o in_progress)...');
      const activeRoute = routes.find(r =>
        r.status === 'pending' || r.status === 'in_progress'
      );

      console.log('🔍 Resultado búsqueda ruta activa:', activeRoute ? `Encontrada: ${activeRoute.name}` : 'No encontrada');

      if (activeRoute) {
        console.log('✅ Ruta activa encontrada:');
        console.log('   - ID:', activeRoute.id);
        console.log('   - Nombre:', activeRoute.name);
        console.log('   - Status:', activeRoute.status);
        console.log('📍 Stops (datos crudos):', activeRoute.stops);
        console.log('📊 Cantidad de stops:', (activeRoute.stops && activeRoute.stops.length) || 0);

        // Validar que stops existe y es un array
        if (!activeRoute.stops || !Array.isArray(activeRoute.stops)) {
          console.error('❌ ERROR: stops no es un array');
          console.error('   Tipo de stops:', typeof activeRoute.stops);
          console.error('   Valor de stops:', activeRoute.stops);
          toast.error('Error: La ruta no tiene paradas válidas');
          setRoute(null);
          setLoading(false);
          console.log('🔍 ===== FIN loadTodayRoute (error: stops inválidos) =====');
          return;
        }

        console.log('🔄 Mapeando stops al formato del frontend...');

        // Mapear stops para que coincidan con los nombres esperados en el frontend
        try {
          activeRoute.stops = activeRoute.stops.map((stop, index) => {
            console.log(`   Mapeando stop ${index + 1}/${activeRoute.stops.length}:`, {
              stop_number: stop.stop_number,
              customer_name: stop.customer_name,
              status: stop.delivery_status || stop.status
            });
            return {
              ...stop,
              status: stop.delivery_status || stop.status,
              customer_address: stop.address_full || stop.customer_address,
              estimated_arrival_time: stop.estimated_arrival || stop.estimated_arrival_time,
              customer_phone: stop.customer_phone || ''
            };
          });

          console.log('✅ Stops mapeados exitosamente');
          console.log('📦 Stops después del mapeo:', activeRoute.stops);
        } catch (mapError) {
          console.error('❌ ERROR al mapear stops:', mapError);
          console.error('❌ Error stack:', mapError.stack);
          toast.error('Error procesando las paradas de la ruta');
          setRoute(null);
          setLoading(false);
          console.log('🔍 ===== FIN loadTodayRoute (error en mapeo) =====');
          return;
        }

        console.log('✅ Estableciendo ruta en el estado');
        setRoute(activeRoute);

        // Encontrar la primera parada no completada
        console.log('🔍 Buscando primera parada pendiente...');
        const firstPendingStop = activeRoute.stops.findIndex(
          s => s.status !== 'completed' && s.status !== 'delivered' && s.status !== 'failed'
        );

        console.log('📌 Índice de primera parada pendiente:', firstPendingStop);
        const stopIndex = firstPendingStop !== -1 ? firstPendingStop : 0;
        console.log('📌 Estableciendo currentStop en:', stopIndex);
        setCurrentStop(stopIndex);

        // Si la ruta está en pending, cambiarla a in_progress automáticamente
        if (activeRoute.status === 'pending') {
          console.log('🔄 Ruta en estado "pending", actualizando a "in_progress"...');
          await updateRouteStatus(activeRoute.id, 'in_progress');
          console.log('✅ Estado de ruta actualizado');
        }

        console.log('🔍 ===== FIN loadTodayRoute (ÉXITO) =====');
      } else {
        console.log('⚠️ No se encontró ruta activa (pending o in_progress)');
        console.log('📋 Rutas disponibles:', routes.map(r => ({
          id: r.id,
          name: r.name,
          status: r.status
        })));
        toast.info('No hay rutas activas para hoy');
        setRoute(null);
        console.log('🔍 ===== FIN loadTodayRoute (sin ruta activa) =====');
      }
    } catch (error) {
      console.error('❌ ===== ERROR en loadTodayRoute =====');
      console.error('❌ Error completo:', error);
      console.error('❌ Error message:', error.message);
      console.error('❌ Error stack:', error.stack);
      console.error('❌ Error response:', error.response && error.response.data);
      console.error('❌ Error status:', error.response && error.response.status);
      toast.error('Error al cargar la ruta del día: ' + error.message);
      setRoute(null);
      console.log('🔍 ===== FIN loadTodayRoute (ERROR) =====');
    } finally {
      setLoading(false);
    }
  };

  const updateRouteStatus = async (routeId, status) => {
    console.log(`🔄 Actualizando estado de ruta ${routeId} a: ${status}`);
    try {
      const response = await apiService.updateRouteStatus(routeId, status);
      console.log('✅ Respuesta del servidor:', response);

      // Mostrar mensaje según el estado
      if (status === 'in_progress') {
        toast.info('Ruta iniciada');
      } else if (status === 'completed') {
        toast.success('🎉 ¡Ruta completada exitosamente!');
      } else if (status === 'cancelled') {
        toast.warning('Ruta cancelada');
      }

      console.log('✅ Estado de ruta actualizado exitosamente');
    } catch (error) {
      console.error('❌ Error actualizando estado de ruta:', error);
      console.error('❌ Error response:', error.response && error.response.data);
      toast.error('Error al actualizar el estado de la ruta');
    }
  };

  const handleCompleteStop = async (stopId, status = 'delivered') => {
    console.log(`🔄 Actualizando parada ${stopId} a estado: ${status}`);
    try {
      const response = await apiService.updateStopStatus(stopId, status);
      console.log('✅ Respuesta de actualización de parada:', response);

      // Mensajes personalizados según el estado
      if (status === 'delivered') {
        toast.success('✅ Entrega completada');
      } else if (status === 'in_route') {
        toast.info('🚗 En ruta hacia el destino');
      } else if (status === 'at_destination') {
        toast.info('📍 Llegaste al destino');
      } else if (status === 'failed') {
        toast.error('❌ Entrega marcada como fallida');
      }

      console.log('🔄 Recargando ruta para actualizar estados...');
      // Recargar ruta para actualizar estados
      await loadTodayRoute();

      // Avanzar al siguiente stop si se completó
      if (status === 'delivered') {
        console.log('➡️  Avanzando a la siguiente parada');
        setCurrentStop(prev => prev + 1);
      }

      // Si todas las paradas están completadas, marcar ruta como completada
      console.log('🔍 Verificando si todas las paradas están completadas...');
      const allCompleted = route.stops.every(
        s => s.status === 'delivered' || s.status === 'completed' || s.status === 'failed'
      );

      console.log('   Todas completadas:', allCompleted);

      if (allCompleted) {
        console.log('🎉 Todas las paradas completadas, finalizando ruta...');
        await updateRouteStatus(route.id, 'completed');
        toast.success('🎉 ¡Ruta completada!');
      }

    } catch (error) {
      console.error('Error completando parada:', error);
      toast.error('Error al actualizar la entrega');
    }
  };

  const handleNavigate = (stop) => {
    // Abrir Google Maps con las coordenadas
    const url = `https://www.google.com/maps/dir/?api=1&destination=${stop.coordinates_latitude},${stop.coordinates_longitude}`;
    window.open(url, '_blank');
  };

  const handleNavigateWaze = (stop) => {
    // Abrir Waze con las coordenadas
    const url = `https://www.waze.com/ul?ll=${stop.coordinates_latitude},${stop.coordinates_longitude}&navigate=yes`;
    window.open(url, '_blank');
  };

  const handleCall = (phone) => {
    if (phone) {
      window.location.href = `tel:${phone}`;
    } else {
      toast.warning('No hay teléfono registrado');
    }
  };

  const getStopStatusColor = (status) => {
    const colors = {
      'pending': '#64748b',
      'in_route': '#2563eb',
      'arrived': '#2563eb',
      'in_transit': '#2563eb',
      'at_destination': '#ea580c',
      'delivered': '#16a34a',
      'completed': '#16a34a',
      'failed': '#dc2626'
    };
    return colors[status] || '#64748b';
  };

  const getStopStatusIcon = (status) => {
    const icons = {
      'pending': '📦',
      'in_route': '🚗',
      'arrived': '🚚',
      'in_transit': '🚚',
      'at_destination': '📍',
      'delivered': '✅',
      'completed': '✅',
      'failed': '❌'
    };
    return icons[status] || '📦';
  };

  const getStopStatusLabel = (status) => {
    const labels = {
      'pending': 'Pendiente',
      'in_route': 'En Ruta',
      'arrived': 'En Destino',
      'in_transit': 'En Ruta',
      'at_destination': 'En Destino',
      'delivered': 'Entregado',
      'completed': 'Entregado',
      'failed': 'Fallido'
    };
    return labels[status] || status;
  };

  if (loading) {
    return (
      <div className="driver-view loading">
        <div className="loading-spinner">⏳</div>
        <p>Cargando ruta del día...</p>
      </div>
    );
  }

  if (!route) {
    return (
      <div className="driver-view no-route">
        <div className="no-route-icon">📍</div>
        <h2>No hay rutas activas</h2>
        <p>No se encontraron rutas asignadas para hoy</p>
        <button className="btn btn-primary" onClick={loadTodayRoute}>
          Recargar
        </button>
      </div>
    );
  }

  // Validar que la ruta tenga stops
  if (!route.stops || route.stops.length === 0) {
    return (
      <div className="driver-view no-route">
        <div className="no-route-icon">⚠️</div>
        <h2>Ruta sin paradas</h2>
        <p>La ruta {route.name} no tiene paradas asignadas</p>
        <button className="btn btn-primary" onClick={loadTodayRoute}>
          Recargar
        </button>
      </div>
    );
  }

  const currentStopData = route.stops[currentStop];
  const completedStops = route.stops.filter(s => s.status === 'delivered' || s.status === 'completed').length;
  const progress = (completedStops / route.stops.length) * 100;

  return (
    <div className="driver-view">
      {/* Header con resumen de ruta */}
      <div className="driver-header">
        <div className="route-info">
          <h1>{route.name}</h1>
          <div className="route-stats">
            <span className="stat">
              📍 {completedStops}/{route.stops.length} entregas
            </span>
            <span className="stat">
              🛣️ {Number(route.total_distance || 0).toFixed(1)} km
            </span>
            <span className="stat">
              ⏱️ {route.estimated_duration || 0} min
            </span>
          </div>
        </div>

        {/* Barra de progreso */}
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <div className="progress-text">
          {Number(progress).toFixed(0)}% completado
        </div>
      </div>

      {/* Parada actual destacada */}
      {currentStopData && currentStopData.status !== 'delivered' && currentStopData.status !== 'completed' && (
        <div className="current-stop-card">
          <div className="stop-header">
            <div className="stop-number-badge">
              Parada {currentStopData.stop_number}
            </div>
            <div className="stop-status" style={{ color: getStopStatusColor(currentStopData.status) }}>
              {getStopStatusIcon(currentStopData.status)} {getStopStatusLabel(currentStopData.status)}
            </div>
          </div>

          <div className="stop-customer">
            <h2>{currentStopData.customer_name || 'Cliente'}</h2>
            {currentStopData.customer_phone && (
              <button
                className="btn-call"
                onClick={() => handleCall(currentStopData.customer_phone)}
              >
                📞 Llamar
              </button>
            )}
          </div>

          <div className="stop-address">
            <div className="address-icon">📍</div>
            <div className="address-text">
              <strong>Dirección:</strong><br />
              {currentStopData.address_full || currentStopData.customer_address || 'Sin dirección'}
              {currentStopData.district && (
                <><br /><strong>Distrito:</strong> {currentStopData.district}</>
              )}
            </div>
          </div>

          <div className="stop-details">
            <div className="detail-item">
              <span className="label">⏰ Ventana de entrega:</span>
              <span className="value">
                {currentStopData.time_window_start || '--:--'} - {currentStopData.time_window_end || '--:--'}
              </span>
            </div>
            <div className="detail-item">
              <span className="label">🕐 Hora estimada llegada:</span>
              <span className="value">{currentStopData.estimated_arrival_time || currentStopData.estimated_arrival || '--:--'}</span>
            </div>
            {currentStopData.distance_from_previous && (
              <div className="detail-item">
                <span className="label">🛣️ Distancia:</span>
                <span className="value">{Number(currentStopData.distance_from_previous || 0).toFixed(2)} km</span>
              </div>
            )}
            {currentStopData.leave_your_order && (
              <div className="detail-item detail-delivery-instructions">
                <span className="label">💬 Instrucciones de entrega:</span>
                <span className="value delivery-note">{currentStopData.leave_your_order}</span>
              </div>
            )}
          </div>

          <div className="stop-actions">
            <div className="navigation-buttons">
              <button
                className="btn btn-success btn-large"
                onClick={() => handleNavigate(currentStopData)}
              >
                🗺️ Google Maps
              </button>
              <button
                className="btn btn-info btn-large"
                onClick={() => handleNavigateWaze(currentStopData)}
              >
                🗺️ Waze
              </button>
            </div>

            {/* Botones de estado */}
            <div className="action-buttons">
              <button
                className="btn btn-info"
                onClick={() => handleCompleteStop(currentStopData.id, 'in_route')}
                disabled={currentStopData.status !== 'pending'}
              >
                🚗 En Ruta
              </button>
              <button
                className="btn btn-warning"
                onClick={() => handleCompleteStop(currentStopData.id, 'at_destination')}
                disabled={currentStopData.status !== 'pending' && currentStopData.status !== 'in_route'}
              >
                📍 En Destino
              </button>
              <button
                className="btn btn-success"
                onClick={() => handleCompleteStop(currentStopData.id, 'delivered')}
                disabled={currentStopData.status === 'pending'}
              >
                ✅ Entregado
              </button>
            </div>

            {/* Botón de entrega fallida */}
            {currentStopData.status !== 'pending' && (
              <button
                className="btn btn-danger btn-block"
                onClick={() => handleCompleteStop(currentStopData.id, 'failed')}
              >
                ❌ No se pudo entregar
              </button>
            )}
          </div>
        </div>
      )}

      {/* Lista de todas las paradas */}
      <div className="stops-list">
        <h3>Todas las Paradas ({route.stops.length})</h3>

        {route.stops.map((stop, index) => {
          const isCurrent = index === currentStop;
          const isCompleted = stop.status === 'delivered' || stop.status === 'completed';
          const isFailed = stop.status === 'failed';

          return (
            <div
              key={stop.id}
              className={`stop-item ${isCurrent ? 'current' : ''} ${isCompleted ? 'completed' : ''} ${isFailed ? 'failed' : ''}`}
              onClick={() => setCurrentStop(index)}
            >
              <div className="stop-item-number">
                {getStopStatusIcon(stop.status)} {stop.stop_number}
              </div>

              <div className="stop-item-info">
                <div className="stop-item-customer">
                  {stop.customer_name || 'Cliente'}
                </div>
                <div className="stop-item-address">
                  📍 {stop.address_full || stop.customer_address || 'Sin dirección'}
                  {stop.district && ` - ${stop.district}`}
                </div>
                <div className="stop-item-time">
                  ⏰ Ventana: {stop.time_window_start || '--:--'} - {stop.time_window_end || '--:--'}
                </div>
                {stop.leave_your_order && (
                  <div className="stop-item-delivery-info">
                    💬 {stop.leave_your_order}
                  </div>
                )}
                <div className="stop-item-status">
                  {getStopStatusIcon(stop.status)} {getStopStatusLabel(stop.status)}
                </div>
              </div>

              <div className="stop-item-actions">
                {!isCompleted && !isFailed && (
                  <>
                    <button
                      className="btn-mini btn-navigate"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleNavigate(stop);
                      }}
                      title="Google Maps"
                    >
                      🗺️
                    </button>
                    <button
                      className="btn-mini btn-navigate-waze"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleNavigateWaze(stop);
                      }}
                      title="Waze"
                    >
                      🧭
                    </button>
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Botón para completar ruta manualmente */}
      {completedStops === route.stops.length && route.status !== 'completed' && (
        <div className="route-complete-card">
          <h2>🎉 ¡Todas las entregas completadas!</h2>
          <button
            className="btn btn-success btn-large"
            onClick={async () => {
              console.log('👆 Clic en botón "Finalizar Ruta"');
              console.log('   Route ID:', route.id);
              console.log('   Paradas completadas:', completedStops);
              console.log('   Total paradas:', route.stops.length);
              await updateRouteStatus(route.id, 'completed');
              console.log('✅ Ruta finalizada, recargando...');
              await loadTodayRoute();
            }}
          >
            Finalizar Ruta
          </button>
        </div>
      )}
    </div>
  );
};

export default DriverView;
